import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Alert, Col, Row, Stack }  from 'react-bootstrap'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { TextInput, Checkbox, IconButton } from '/src/components/common'
import { postRequest } from '/src/httpClient'
import { useCredit } from '/src/hooks'

import { AccountPasswordForm } from './AccountPasswordForm'

import './account_form.scss'

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

const formatCreditValue = ({ creditLimit, creditExposureValue }) => {
  return formatter.format(creditLimit - creditExposureValue)
}

const AccountTradeFormCreditElement = ({ register }) => {
  const credit = useCredit()

  return (
    <TextInput 
      label="Available Credit" 
      type="text"
      value={credit ? formatCreditValue(credit) : 'loading...'}
      register={register('credit', {
        disabled: true
      })} 
    />
  )
}

const AccountTradeFormElements = ({ user, register }) => {
  return (
    <Row className="mb-4">
      <Col sm={12}>
        <AccountTradeFormCreditElement register={register} />
      </Col>
      <Col sm={6}>
        <TextInput 
          label="Account name" 
          type="text"
          value={user.trade_name}
          register={register('trade_name', {
            disabled: true
          })} 
        />
      </Col>
      <Col sm={6}>
        <TextInput 
          label="Additional account name" 
          type="text"
          value={user.trade_name_second}
          register={register('trade_name_second', {
            disabled: true
          })}  
        />
      </Col>
    </Row>
  )
}

export const AccountForm = ({ user }) => {
  const { register, formState: { errors }, setError, handleSubmit } = useForm({
    defaultValues: {
      first_name: user ? user.field_first_name : '',
      last_name: user ? user.field_last_name : '',
      email: user ? user.mail : '',
      phone: user ? user.field_phone : '',
      company: user ? user.field_company : '',
      newsletter: user ? user.field_news_letter_subscription : 0
    }
  })

  const onSubmit = (data) => {
    // Request current user update.
    postRequest('/api/user/update', data)
  }

  if (!user) {
    return <></>
  }

  return (
    <div className="account-form-container">
      <form id="account-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="title-container mb-4">
          <h4 className='title'>Account Details</h4>
        </div>
        {user.trade_name && (
          <>
            <Row className="mb-4">
              <Col sm={12}>
                <Alert variant="warning">
                  <p>Please note, to update trade account details please call your account manager.</p>
                </Alert>
              </Col>
            </Row>
            <AccountTradeFormElements user={user} register={register} />
          </>
        )}
        <Row className="mb-4">
          <Col sm={6}>
            <TextInput label="First name" type="text" error={errors.first_name} register={register('first_name', {
              disabled: user.trade_name ? true : false,
              required: true
            })} />
          </Col>
          <Col sm={6}>
            <TextInput label="Last name" type="text" error={errors.last_name} register={register('last_name', {
              disabled: user.trade_name ? true : false,
              required: true
            })} />
          </Col>
          <Col sm={12}>
            <TextInput label="Email" type="text" error={errors.email} register={register('email', {
              disabled: true,
              required: true
            })} />
          </Col>
          <Col sm={6}>
            <TextInput label="Phone" type="text" error={errors.phone} register={register('phone', {
              disabled: user.trade_name ? true : false,
              required: true
            })} />
          </Col>
          <Col sm={6}>
            <TextInput label="Company" type="text" error={errors.company} register={register('company', {
              disabled: user.trade_name ? true : false,
              required: true
            })} />
          </Col>
          <Col sm={12}>
            <Checkbox 
              label="Newsletter" 
              error={errors.newsletter} 
              register={register('newsletter', {
                required: false
             })} />
          </Col>
        </Row>
        <Row>
          <Stack direction="horizontal" gap={4}>
            {!user.trade_name && (
              <IconButton type="submit" icon={faArrowRight}>
                Update Details
              </IconButton>
            )}
          </Stack>
        </Row>
      </form>
      <div className="title-container mt-5 mb-4">
        <h4 className='title'>Account Password</h4>
      </div>
      <AccountPasswordForm user={user} />
    </div>
  )
}

export default AccountForm